import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bamboohrEmployees } from "actions/members";
import ContentHeader from "pages/Profile/components/ContentHeader";
import Form from "../Form";

import styles from "./AddMember.module.scss";

const AddMember = ({ memberDetails, setCurrentScreen }) => {
  const dispatch = useDispatch();
  const [employeesList, setEmployeesList] = useState([]);

  const employees = useSelector((state) => state.members);

  useEffect(() => {
    dispatch(bamboohrEmployees);
  }, [dispatch]);

  useEffect(() => {
    employees?.bamboohrEmployees &&
      setEmployeesList(employees.bamboohrEmployees);
  }, [employees]);

  return (
    <>
      <ContentHeader
        title="Add Team Member"
        handleClickBack={() => setCurrentScreen("")}
        className={styles.header}
      />

      <div className={styles.wrapper}>
        <Form data={memberDetails} state="add" employeesList={employeesList} />
      </div>
    </>
  );
};

export default AddMember;
